import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-processmanager-logo',
    templateUrl: './processmanager-logo.component.html',
    styleUrls: ['./processmanager-logo.component.css'],
    standalone: false
})
export class ProcessmanagerLogoComponent implements OnInit {
  @Input()
  logo = 'ProcessManagerLogo';

  get logoSrc() {
    return `assets/${this.logo}.svg`;
  }

  constructor() { }

  ngOnInit() {
  }
}
